// Button & toolbar
import Button from '@/components/button'

// Form
import TextField from '../components/text-field'
import DateField from '../components/date-field'
import NumberField from '../components/number-field'
import Radio from '../components/radio'
import RadioGroup from '../components/radio-group'
import Checkbox from '../components/checkbox'
import CheckboxGroup from '../components/checkbox-group'
import MsSwitch from '../components/switch'
import MsTimeField from '../components/time-field'
import MsComboBox from '../components/combo-box'
import Label from '../components/label'
import Dialog from '../components/dialog'
import Tag from '../components/tag'
import Upload from '../components/upload-field'
import SafeDisplay from '../components/safe-display'
// Extra
import Preview from '../components/preview'
import Rate from '../components/rate'
import Progress from '../components/progress'
import Form from '../components/form'

const components = [
  Button,
  TextField,
  DateField,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Rate,
  Progress,
  NumberField,
  MsSwitch,
  MsTimeField,
  MsComboBox,
  Label,
  Dialog,
  Tag,
  Form,
  Preview,
  Upload,
  SafeDisplay
]

export default (app) => {
  components.forEach((component) => {
    app.component(component.name, component)
  })
}
